var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClip({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.62675 1.38467C10.473 -0.461557 13.4662 -0.461557 15.3124 1.38467C17.1586 3.2309 17.1586 6.2241 15.3124 8.07033L7.37825 16.0045C6.16494 17.2178 4.19756 17.2178 2.98425 16.0045C1.77094 14.7912 1.77094 12.8238 2.98425 11.6105L9.38634 5.20842C9.67923 4.91553 10.1541 4.91553 10.447 5.20842C10.7399 5.50131 10.7399 5.97619 10.447 6.26908L4.04491 12.6712C3.41739 13.2987 3.41739 14.3163 4.04491 14.9438C4.67244 15.5714 5.69006 15.5714 6.31759 14.9438L14.2518 7.00967C15.5122 5.74923 15.5122 3.70577 14.2518 2.44533C12.9913 1.18489 10.9479 1.18489 9.68741 2.44533L1.28033 10.8524C0.987437 11.1453 0.512563 11.1453 0.21967 10.8524C-0.0732233 10.5595 -0.0732233 10.0846 0.21967 9.79175L8.62675 1.38467Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClip);
export default __webpack_public_path__ + "static/media/clip.4af445376e6fac4cbb1f5fa2dae66c56.svg";
export { ForwardRef as ReactComponent };